var Timer = (function () {
    function Timer() {
        this.intervalId = -1;
        this.fireCount = -1;
        this.isRunning = false;
    }
    Timer.prototype.start = function (delay, callback, fireCount) {
        if (delay === void 0) { delay = 1000; }
        if (fireCount === void 0) { fireCount = -1; }
        this.fireCount = fireCount;
        this.stop();
        if (callback)
            this.callback = callback;
        this.intervalId = window.setInterval(this.onTimeOut.bind(this), delay);
        this.isRunning = true;
    };
    Timer.prototype.onTimeOut = function () {
        this.fire();
    };
    Timer.prototype.fire = function () {
        if (this.callback)
            this.callback.call();
        if (this.fireCount > 0) {
            this.fireCount--;
            if (this.fireCount <= 0) {
                this.stop();
            }
        }
    };
    Timer.prototype.stop = function () {
        this.isRunning = false;
        if (this.intervalId < 0)
            return;
        window.clearInterval(this.intervalId);
        this.intervalId = -1;
    };
    return Timer;
}());
export default Timer;



//////////////////
// WEBPACK FOOTER
// ./src/utils/Timer.ts
// module id = Huue
// module chunks = 10